import invoicesService from "@/modules/invoices/services/invoicesService";
import { i18n } from "@/plugins/i18n";

const state = {
  invoices: {},
};

const getters = {
  invoiceByUid: (state) => (uid) => state.invoices[uid],
  creditAvailableByUid: (state) => (uid) => {
    const invoice = state.invoices[uid];
    if (!invoice || !invoice.payment_status || !invoice.amount) return '0.00';

    const total = parseFloat(invoice.amount) || 0;
    const credited = parseFloat(invoice.payment_status.amount_credited) || 0;
    const available = total - credited;

    // Return formatted string with currency
    if (invoice.amount_h) {
      return invoice.amount_h.replace(
        /[\d,.]+/,
        available.toFixed(2),
      );
    }
    return `${available.toFixed(2)}`;
  },
  // TODO: Implement credit note subtotal calculation
  creditSubtotalByUid: () => () => '0.00',
  // TODO: Implement credit note tax calculation
  creditTaxByUid: () => () => '',
  // TODO: Implement credit note total calculation
  creditTotalByUid: () => () => '0.00',
};

const mutations = {
  setInvoice(state, invoice) {
    state.invoices = {
      ...state.invoices,
      [invoice.uid]: invoice,
    };
  },
  updateInvoice(state, updatedFields) {
    state.invoices = {
      ...state.invoices,
      [updatedFields.uid]: {
        ...state.invoices[updatedFields.uid],
        ...updatedFields,
      },
    };
  },
};

const actions = {
  async fetchInvoice({ commit }, invoiceUid) {
    const invoice = await invoicesService.fetchInvoice(invoiceUid);
    commit("setInvoice", invoice);
    return invoice;
  },
  async cancelInvoice({ commit }, { payableUid, payload }) {
    const cancelInvoiceResponse = await invoicesService.cancelInvoice(payableUid, payload);
    commit("updateInvoice", cancelInvoiceResponse.data.invoice);
    return cancelInvoiceResponse;
  },
  async createCreditNote(
    { dispatch },
    { invoiceUid, sourcePaymentUid, refundAmount, invoiceOriginalAmount }
  ) {
    let lineItems = [];
    let creditNoteReason = "";
    const isFullRefund = parseFloat(refundAmount) === parseFloat(invoiceOriginalAmount);

    if (isFullRefund) {
      const invoice = await invoicesService.fetchInvoice(invoiceUid);

      const invoiceLineItems = invoice.items.concat(
        invoice.sections?.flatMap((section) => section.items) || []
      );

      creditNoteReason = i18n.t("refund_dialog.credit_note_reason.full_refund");
      lineItems = invoiceLineItems.map((item) => ({
        name: item.name,
        quantity: item.quantity,
        unit_amount: item.rate,
        taxes: item.taxes,
      }));
    } else {
      creditNoteReason = i18n.t("refund_dialog.credit_note_reason.partial_refund");
      const partialRefundItemName = i18n.t("refund_dialog.credit_note_partial_refund_item_name");
      lineItems = [
        {
          name: partialRefundItemName,
          quantity: 1,
          unit_amount: refundAmount,
        },
      ];
    }

    const creditNotePayload = {
      invoice_uid: invoiceUid,
      line_items: lineItems,
      notes: creditNoteReason,
      source_payment_uid: sourcePaymentUid,
    };
    const response = await invoicesService.createCreditNote(creditNotePayload);

    // Refresh the payment in the payments store
    dispatch("PaymentsStore/fetchPayment", { uid: sourcePaymentUid }, { root: true });

    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
